export default __webpack_public_path__ + "static/media/11.3e5e415b.png";